import { dateTimeFormatter } from '@rbx/core';
import { Locale } from '@rbx/intl';

export const formatDate = (date: string | Date, locale: Locale): string => {
  const parsedDate: Date = typeof date === 'string' ? new Date(date) : date;
  return dateTimeFormatter(locale).getCustomDateTime(parsedDate, {
    dateStyle: 'medium',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
};

export const setToUtcMidnight = (given: Date): Date => {
  return new Date(given.toISOString().slice(0, 10));
};

export const getDateDaysAgoTime = (days: number): number => {
  return Date.now() - days * 24 * 60 * 60 * 1000;
};
